<template>
  <div class="style-btn-box">
    <div>
      <div class="font-weight-bold">{{ 'Style' | trans }}</div>
    </div>

    <router-link
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        :to="{name:'StyleCanvas', params: {uuid: id}}"
    >
      <div class="style-btn" @click="navigate">
        <div class="style-btn-left">
          <div><img :alt="currentStyle.name" :srcset="`${currentStyle.path.sidebar['1x']} 1x,  ${currentStyle.path.sidebar['2x']} 2x, ${currentStyle.path.sidebar['3x']} 3x,  ${currentStyle.path.sidebar['4x']} 4x`"></div>
          <div>{{ currentStyle.name | trans }}</div>
        </div>
        <div><i class="fa fa-chevron-right"></i></div>
      </div>
    </router-link>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import StylesManager from "../../manager/StylesManager";

export default {
  name: "Styles",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {
    currentStyle() {
      return StylesManager.getStyleByName(this.creatorStudio.settings.conversion.options.style);
    }
  }
};
</script>
<style lang="scss">

.style-btn-box {
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.style-btn {
  cursor: pointer;
  height: 70px;
  width: 100%;
  background: #383838;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 9px;
  padding-right: 20px;

  &:hover {
    background: #323232;
  }

  .style-btn-left {
    padding-left: 3px;
    gap: 20px;
    display: flex;
    align-items: center;
    font-size: 17px;
  }
}
</style>
